<template>
  <div id="aboutUs2">
    <div class="wrapper">
      <!-- <img class="back" src="@/assets/vector/BG.svg"> -->
      <div id="textWrapper">
  
  
   <h2>O нас в цифрах</h2>
   <p>Статистика собранная несколькими годами плотной работы</p>
   <div class="flexContainer">
     <div>
   <h2>11,9%</h2>
     <p>Годовая ставка</p>
     </div>
     <svg width="50" height="1" viewBox="0 0 50 1" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'miniline'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path opacity=".4" stroke="#fff" d="M0 .5h50"/></svg>
     <div>
   <h2>97%</h2>
       <p>Одобрение</p>
       </div>
<svg width="50" height="1" viewBox="0 0 50 1" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'miniline'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path opacity=".4" stroke="#fff" d="M0 .5h50"/></svg>
<div>
   <h2>₽ 100 000</h2>
       <p>Кредитный лимит</p>
       </div>
       <svg width="50" height="1" viewBox="0 0 50 1" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'miniline'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path opacity=".4" stroke="#fff" d="M0 .5h50"/></svg>
       <div>
   <h2>17263</h2>
       <p>Карт выдано</p>
       </div>
</div>
       </div> 
       </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs2',
}
</script>

<style scoped>
.back{position: absolute; min-width: 100%; min-height: 65%;}
#textWrapper{ position: relative;padding-top: 6vw;padding-left: 16vw; padding-right: 16vw;text-align: center;padding-bottom: 19vw;}
 p, h2 {color:white;text-align: center;}
 h2{padding-top:4vw; padding-bottom:2vw;}
#aboutUs2{position: relative;overflow: hidden;width:100%; background-image: url("../assets/vector/BG.svg"); background-size: cover; background-repeat: no-repeat; }
 ul > li{position: relative;}
 ul > li:after{content: ''; width: 30vw;height: 1px;bottom:0px;left:calc(50% - 15vw);position: absolute;background:red;}

  @media screen and (min-width: 1140px) {
    .flexContainer{display: flex;justify-content: center;column-gap: 40px;}
    h2{font-size: 30px;padding-top: 42px;padding-bottom: 20px;}
    p{font-size: 17px;}
    .miniline{transform: rotate(270deg); width: 111px;height: 180px; }
    #textWrapper{ padding-top: 0vw;padding-left: 0vw;padding-right: 0vw;padding-bottom:20px;}
    #aboutUs2{position: relative;overflow: hidden;width:100%; background-image: url("../assets/vector/BG2.svg"); background-size: cover; background-repeat: no-repeat; }
    }

</style>